import React from 'react';

const ExchangeContext = React.createContext({});
export default ExchangeContext;
